import React from "react";
import "../../styles/base/baseline.css";
import "../../styles/pages/404.css";

import bg from "../../assets/images/img/bg.webp";
import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";

export default function NotFound() {
  return (
    <div className="main-wrapper" style={{marginBottom: "80px"}}>
      <img
        alt="scrollDown"
        src={bg2}
        className="landing__image-background-2 image-background"
      />
      <div
        className="rotated-text"
        onClick={() => (window.location.href = "#scroll")}
        style={{ cursor: "pointer" }}
      >
        <img src={arrow} alt="downarrow" />
        <h4> scroll down</h4>
      </div>

      <div className="section__landing about-page">
        <picture>
          <source media="(max-width: 650px)" srcSet={bg} />
          <img
            alt="container background"
            src={bg}
            className="landing__image-background-1 image-background"
          />
        </picture>
        <div className="container">
          <div className="logo-gradient"></div>
          <div className="content" style={{ width: "100%", maxWidth: 560 }}>
            <h1 className="oops">Oops!</h1>
            <h1 className="second">
              We couldn’t find the page you’re looking for.
            </h1>
            <p className="desc" style={{paddingTop:"48px", paddingBottom: "48px"}}>
              It might have been moved or no longer exists. Return to the
              homepage and continue exploring.
            </p>
            <button
              onClick={() => (window.location.href = "/")}
              className="btn blue"
            >
              Back to the main page
            </button>
          </div>
        </div>
      </div>
    </div>
    // <div className="main-wrapper">
    //   <img
    //     loading="lazy"
    //     src="https://specodit.pl/wp-content/themes/specodit/assets/images/404/lewo.svg"
    //     alt="left-ornament"
    //     className="left"
    //   />
    //   <img
    //     loading="lazy"
    //     src="https://specodit.pl/wp-content/themes/specodit/assets/images/404/prawo.svg"
    //     alt="right-ornament"
    //     className="right image-background"
    //   />
    //   <img
    //     loading="lazy"
    //     src="https://specodit.pl/wp-content/themes/specodit/assets/images/404/404.svg"
    //     alt="404"
    //     className="error"
    //   />
    //   <div className="content">
    //     <h1 className="oops">Oops!</h1>
    //     <h1 className="second">
    //       We couldn’t find the page you’re looking for.
    //     </h1>
    //     <p className="desc">
    //       It might have been moved or no longer exists. Return to the homepage
    //       and continue exploring.
    //     </p>
    //     <button
    //       onClick={() => (window.location.href = "/")}
    //       className="btn blue"
    //     >
    //       Back to the main page
    //     </button>
    //   </div>
    // </div>
  );
}
